import { styled, alpha } from '@mui/material/styles'
import { InputBase, IconButton, Fab } from '@mui/material'
import { colorPalette } from '../../style/colorPalette'

// 画面右下に常時表示するフローティングの起動ボタン。
export const ChatFab = styled(Fab)({
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 1300,
  backgroundColor: colorPalette.skyBlue[7],
  color: colorPalette.monotone[0],
  '&:hover': {
    backgroundColor: colorPalette.skyBlue[8],
  },
})

// 起動ボタンの上に開くチャットパネル本体。
export const ChatPanel = styled('div')({
  position: 'fixed',
  bottom: 96,
  right: 24,
  zIndex: 1300,
  width: 760,
  maxWidth: 'calc(100vw - 48px)',
  height: 1040,
  maxHeight: 'calc(100vh - 140px)',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colorPalette.monotone[0],
  borderRadius: 12,
  border: `1px solid ${colorPalette.monotone[2]}`,
  boxShadow: '0 8px 24px rgba(36, 48, 80, 0.2)',
  overflow: 'hidden',
})

export const PanelHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  borderBottom: `1px solid ${colorPalette.monotone[2]}`,
  backgroundColor: colorPalette.monotone[1],
})

export const HeaderTitle = styled('span')({
  fontWeight: 600,
  fontSize: 14,
  color: colorPalette.monotone[10],
})

export const HeaderActions = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
})

export const InputArea = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: 12,
  borderTop: `1px solid ${colorPalette.monotone[2]}`,
})

export const ChatInput = styled(InputBase)({
  flexGrow: 1,
  backgroundColor: colorPalette.monotone[0],
  borderRadius: 4,
  padding: '8px 12px',
  border: `1px solid ${colorPalette.monotone[2]}`,
  fontSize: 14,
  '&:hover': {
    borderColor: colorPalette.monotone[4],
  },
  '&.Mui-focused': {
    borderColor: colorPalette.skyBlue[7],
    boxShadow: `0 0 0 2px ${alpha(colorPalette.skyBlue[7], 0.2)}`,
  },
})

export const SendButton = styled(IconButton)({
  color: colorPalette.skyBlue[7],
  '&.Mui-disabled': {
    color: colorPalette.monotone[3],
  },
})

export const HeaderIconButton = styled(IconButton)({
  color: colorPalette.monotone[4],
  '&:hover': {
    color: colorPalette.monotone[6],
  },
  '&.Mui-disabled': {
    color: colorPalette.monotone[3],
  },
})

export const InlineError = styled('div')({
  padding: '4px 16px',
  color: colorPalette.pink[7],
  fontSize: 12,
})
